module.exports = __webpack_public_path__ + "img/atividades.3fed3aa6.png";